module.exports = __webpack_public_path__ + "SourceSans3-LightIt.otf.c72b0.woff";